import React from 'react'

/**
* @author
* @function LoadingBox
**/

const LoadingBox = (props) => {
  return(
    <div className="loading">
        <i className="fa fa-spinner fa-spin"></i> Loading...
    </div>
   )

 }

export default LoadingBox